/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { AccountEntitySearch, EditAccountEntity, GetAccountQuery, OpportunityField } from '../models/AccountEntity';
import  AccountCreateRequestDTO  from '../models/Accounts/AccountCreateRequestDTO'
import { RemoteSelectOption } from 'src/types';

export class SalesforceAccountControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) { }

    public getAccounts(query: GetAccountQuery): CancelablePromise<{ totalCount: number, data: AccountEntitySearch[] }> {
        if (!query.limit) {
            query.limit = 50;
        }
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/account',
            query,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getAccount(id: string): CancelablePromise<{ totalCount: number, data: AccountEntitySearch[] }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/account',
            query: { accountId: id, limit: 1 },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getAccountsCompany(recordTypeAziendaId: string, limit: number = 200, skip: number = 0): CancelablePromise<{ totalCount: number, data: AccountEntitySearch[] }> {
        return this.httpRequest.request({
            method: 'GET',
            query: { record_type: recordTypeAziendaId, limit, skip },
            url: '/register/account',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getAccountFields(): CancelablePromise<{ data: OpportunityField[] }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/account/fields',
            // query: { accountId: id},
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public createAccount(body: AccountCreateRequestDTO): CancelablePromise<any> {
        // body.Flotta_Potenziale_LCV__c = body.Flotta_Potenziale_LCV__c ?? 0;
        // body.Flotta_Potenziale_PC__c = body.Flotta_Potenziale_PC__c ?? 0;
        // body.Flotta_Totale_PC__c = body.Flotta_Totale_PC__c ?? 0;
        // body.Flotta_Totale_LCV__c = body.Flotta_Totale_LCV__c ?? 0;

        return this.httpRequest.request({
            method: 'POST',
            url: '/register/account',
            body,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public editAccount(id: string, body: EditAccountEntity): CancelablePromise<any> {
        // body.Flotta_Potenziale_LCV__c = body.Flotta_Potenziale_LCV__c ?? 0;
        // body.Flotta_Potenziale_PC__c = body.Flotta_Potenziale_PC__c ?? 0;
        // body.Flotta_Totale_PC__c = body.Flotta_Totale_PC__c ?? 0;
        // body.Flotta_Totale_LCV__c = body.Flotta_Totale_LCV__c ?? 0;

        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/account/' + id,
            body,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getAccountTypes(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/account/recordType',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

	public getSalesUsers(): CancelablePromise<string[]> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/users/sales',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public getReferenceUsers(): CancelablePromise<RemoteSelectOption[]> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/users/reference',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public getBackupUsers(): CancelablePromise<string[]> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/register/users/backup',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}
}
